import { useFormikContext } from 'formik';
import React, { useEffect } from 'react';
import { SelectFieldGroup } from 'shared/formik/SelectFieldGroup';
import { TextFieldGroup } from 'shared/formik/TextFieldGroup';
import { addressJoin, AddressSegments, defaultAddressSegments } from './segments';
import { FieldNames, StateOptions } from './utils';

interface Props {
  fieldNames: FieldNames;
  error?: string;
  children?: React.ReactChild;
}

export const FourPartAddress = ({ fieldNames, error, children }: Props) => {
  const context = useFormikContext();
  const values = context.values as { [key: string]: any };

  // ensure any change to address fields recompile the full address
  // the linting rule is incorrect, as it wants to add context to the deps which results in an infinite render loop
  /* eslint-disable react-hooks/exhaustive-deps */
  useEffect(() => {
    const addressSegments = Object.keys(fieldNames)
      .map(key => key as keyof AddressSegments)
      .reduce<AddressSegments>((obj, key) => {
        obj[key] = values[fieldNames[key]] ?? '';
        return obj;
      }, {...defaultAddressSegments});
    context.setFieldValue(fieldNames.fullAddress, addressJoin(addressSegments));
  }, [
    values[fieldNames.street],
    values[fieldNames.suburb],
    values[fieldNames.state],
    values[fieldNames.postcode]
  ]);
  /* eslint-enable */

  return (
    <>
      <div className="form-row">
        <div className="col-md-12">
          <TextFieldGroup
            label="Street No &amp; name"
            name={fieldNames.street}
            maxLength={255}
            error={error}
          />
        </div>
      </div>
      <div className="form-row">
        <div className="col-md-3">
          <TextFieldGroup
            label="Suburb / Town"
            name={fieldNames.suburb}
            maxLength={100}
          />
        </div>
        <div className="col-md-2">
          <SelectFieldGroup label="State" name={fieldNames.state} blank={true} custom>
            {StateOptions.map(s=> <option key={s[0]} value={s[0]}>{s[1]}</option>)}
          </SelectFieldGroup>
        </div>
        <div className="col-md-2">
          <TextFieldGroup
            label="Postcode"
            name={fieldNames.postcode}
            maxLength={4}
            pattern="\d*"
            inputMode="numeric"
          />
        </div>
        {children}
      </div>
    </>
  );
}